import {TitleEnum} from '../Enums';
import {LocalStorageObject} from '../Utilities';
import {Model} from './Model';
import {LeadTrackingPermission} from './LeadTrackingPermission';

export class User extends Model implements LocalStorageObject {
  accountCode: number | null = null; // not available on guest login
  zbdId: number | null = null; // not available on guest login
  salutation: number | null = null;
  title: number = TitleEnum.NONE.value;
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  street: string = '';
  houseNr: string = '';
  company: string = '';
  additionalInformation: string = '';
  zip: string = '';
  city: string = '';
  state: number | null = null;
  country: number | null = null;
  addressType: number | null = null;
  permissions: Array<LeadTrackingPermission> = [];

  constructor(data: any) {
    super(data);
    this.fromStorage(data);
  }

  public toString(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  fromStorage(data: any) {
    this.accountCode = User.notSet(data.accountCode) ? this.accountCode : data.accountCode;
    this.zbdId = User.notSet(data.zbdId) ? this.zbdId : data.zbdId;
    this.salutation = User.notSet(data.salutation) ? this.salutation : data.salutation;
    this.title = User.notSet(data.title) ? this.title : data.title;
    this.firstName = User.notSet(data.firstName) ? this.firstName : data.firstName;
    this.lastName = User.notSet(data.lastName) ? this.lastName : data.lastName;
    this.email = User.notSet(data.email) ? this.email : data.email;
    this.street = User.notSet(data.street) ? this.street : data.street;
    this.houseNr = User.notSet(data.houseNr) ? this.houseNr : data.houseNr;
    this.company = User.notSet(data.company) ? this.company : data.company;
    this.additionalInformation = User.notSet(data.additionalInformation) ? this.additionalInformation : data.additionalInformation;
    this.zip = User.notSet(data.zip) ? this.zip : data.zip;
    this.city = User.notSet(data.city) ? this.city : data.city;
    this.state = User.notSet(data.state) ? this.state : data.state;
    this.country = User.notSet(data.country) ? this.country : data.country;
    this.addressType = User.notSet(data.addressType) ? this.addressType : data.addressType;
    if (data.permissions && Array.isArray(data.permissions) && data.permissions.length > 0) {
      this.permissions = data.permissions.map(p => new LeadTrackingPermission(p));
    }

    return this;
  }

  private static notSet(value: any): boolean {
    return value === undefined || value === null;
  }
}
